<button (click)="downloadData()" [disabled]="isDownloadingData" class="button is-small has-icon">
  <span class="icon"><i class="fas fa-table"></i></span>
  <span><tra slug="g9_export"></tra></span>
</button>